import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

export function logEventWithPrefixAnalyticsUtil (prefix, eventName, properties) {
  if (prefix) {
    eventName = getActionStrReduxUtil(prefix, eventName)
  }

  return logEventAnalyticsUtil(eventName, properties)
}
